import React from 'react';
import _ from 'underscore';
import { Subtract } from 'utility-types';

import { FilterUpdaterOwnProps, withFilterUpdater } from '../../app/spaces/helpers/FilterUpdater';
import { SortOrderUpdaterOwnProps, withSortOrderUpdater } from '../../app/spaces/helpers/SortOrderUpdater';
import { ConnectedPublishedConnectionSpace } from './ConnectedPublishedConnectionSpace';
import { PublishedConnectionSpaceOwnProps } from './PublishedConnectionSpace';
import {
  InjectedPublishedConnectionSpaceDataFetcherProps,
  PublishedConnectionSpaceDataFetcherProps,
  withPublishedConnectionSpaceDataFetcher,
} from './PublishedConnectionSpaceDataFetcher';
import {
  InjectedPublishedConnectionSpaceServiceInjectorProps,
  PublishedConnectionSpaceServiceInjectorProps,
  withPublishedConnectionSpaceServiceInjector,
} from './PublishedConnectionSpaceServiceInjector';

export type PublishedConnectionSpaceProviderProps =
  FilterUpdaterOwnProps &
  SortOrderUpdaterOwnProps &
  PublishedConnectionSpaceDataFetcherProps &
  PublishedConnectionSpaceServiceInjectorProps &
  Subtract<Subtract<PublishedConnectionSpaceOwnProps, InjectedPublishedConnectionSpaceDataFetcherProps>, InjectedPublishedConnectionSpaceServiceInjectorProps>;

export const PublishedConnectionSpaceProvider: React.ComponentType<PublishedConnectionSpaceProviderProps> = _.compose(
  withFilterUpdater,
  withSortOrderUpdater,
  withPublishedConnectionSpaceDataFetcher,
  withPublishedConnectionSpaceServiceInjector,
)(ConnectedPublishedConnectionSpace);
